import type { Parser } from 'mathjs';

import isNil from 'lodash/isNil';
import isFinite from 'lodash/isFinite';
import round from 'lodash/round';

import { keysFrom } from './keysFrom';

import { AbstractFormulaParser, Scope } from './AbstractFormulaParaser';

export class CustomFormulaParser extends AbstractFormulaParser {
    protected fixName(name: string): string {
        return name.replace(/ /g, '').replace(/:/g, '_');
    }

    protected formatResult(result: any): any {
        return isFinite(result) && result !== 0 ? round(result, 4) : result;
    }

    protected override createParser(scope: Scope, entryCreationTime: Date): Parser {
        const parser = super.createParser(scope, entryCreationTime);

        keysFrom(scope).forEach(name => {
            parser.set(this.fixName(name), scope.get(name));
        });

        return parser;
    }

    protected mapScope(scope: Scope): Scope {
        scope.set('getSumOfNumberArrayValues', this.getSumOfNumberArrayValues);

        keysFrom(scope).forEach(name => {
            const value = scope.get(name);
            if (!isNil(value) && typeof value === 'object') {
                Object.keys(value).forEach(subName => {
                    scope.set(this.makeSubValueScopeName(name, subName), value[subName]);
                });
            }
        });

        return scope;
    }

    private makeSubValueScopeName(fieldName: string, subName: string): string {
        return `${fieldName}__${subName}`;
    }

    private getSumOfNumberArrayValues(values: string[] = []): number {
        return values.reduce((acc, value) => acc + Number(value), 0);
    }
}
